export default __webpack_public_path__ + "static/media/920.801e94aa.png";